export default __webpack_public_path__ + "static/media/slide1.02d885e4.jpg";